module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('div', {
    staticClass: "flex-grow flex items-center"
  }, [_c('div', {
    staticClass: "flex items-center flex-wrap"
  }, [_c('img', {
    staticClass: "avatar mr-3 w-7 h-7 rounded-full",
    class: _vm.showCollapseButton ? 'submission-open' : 'submission-closed',
    attrs: {
      "src": _vm.avatar_URL
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openAnonymityModal.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "mr-2 text-sm font-semibold font-poppins text-gray-800",
    class: _vm.handleHoverSubmissionCard,
    on: {
      "click": function($event) {
        return _vm.$emit('openSubmission')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isInPlag && _vm.getCurrentRT.enable_annonymous ? _vm.plagPanelName : _vm.name) + "\n        ")]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": _vm.formated_submission_date(_vm.submission.start_date),
      "padding": "px-3 py-1.5",
      "styleTooltip": "top-0 left-full -mt-1.5 ml-2"
    }
  }, [(_vm.is_version_changed) ? _c('span', {
    staticClass: "text-xs text-gray-600"
  }, [_vm._v(" " + _vm._s(_vm.version_date) + " ")]) : _c('span', {
    staticClass: "text-xs text-gray-600"
  }, [_vm._v(_vm._s(_vm.submission_date_time_ago))])]), _vm._v(" "), (_vm.showCollapseButton) ? _c('Tooltip', {
    attrs: {
      "text": "Collapse",
      "padding": "px-3 py-1.5",
      "styleTooltip": "top-0 left-full -mt-1.5 ml-2"
    }
  }, [_c('button', {
    staticClass: "w-8 h-8 hover:bg-gray-200 rounded-full ml-2",
    on: {
      "click": function($event) {
        return _vm.closeSubmission()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-up"
  })])]) : _vm._e(), _vm._v(" "), (_vm.loadingSubmission) ? _c('div', {
    staticClass: "ml-2"
  }, [_c('pl-spinner')], 1) : _vm._e()], 1), _vm._v(" "), (_vm.roundtable_end_date < _vm.submission_date && !_vm.is_submission_edited) ? _c('h6', {
    staticClass: "text-red-500 text-xs ml-3 mt-0.5"
  }, [_vm._v("\n        Submitted after close\n      ")]) : _vm._e(), _vm._v(" "), (_vm.is_submission_edited && _vm.submission_date > _vm.roundtable_end_date) ? _c('h6', {
    staticClass: "text-red-500 text-xs ml-3 mt-0.5"
  }, [_vm._v("\n        Edited after close\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('Tooltip', {
    attrs: {
      "text": "Used Genie Feedback. Click to see more",
      "styleTooltip": "top-0 right-full mr-2 -mt-1 shadow-md text-gray-800",
      "backgroundColor": "bg-white",
      "textColor": "text-gray-800"
    }
  }, [(_vm.hasTeacherPermissionsInCourse && _vm.submissionTypeDraft) ? _c('button', {
    staticClass: "rounded-full mt-1 mr-1.5 w-4 h-4",
    on: {
      "click": function($event) {
        return _vm.handleOpenGenieFeedback()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/roundtable_options_create/genie_icon.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isInPlag && _vm.canSeeEdit && _vm.versionNumbers.length > 1) ? _c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('v-dropdown', {
    attrs: {
      "placement": "right"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('div', {
          staticClass: "flex justify-between items-center px-3 py-2 hover:bg-gray-100 rounded-md text-xs"
        }, [_c('button', {
          staticClass: "mr-2"
        }, [_vm._v("\n                " + _vm._s('Edited (v' + _vm.selected_version + ')') + "\n              ")]), _vm._v(" "), _c('i', {
          staticClass: "fa-solid fa-angle-down"
        })])]
      },
      proxy: true
    }, {
      key: "content",
      fn: function() {
        return [_c('ul', _vm._l((_vm.versionNumbers), function(version, index) {
          return _c('li', {
            key: index,
            staticClass: "py-3 px-3 hover:bg-coolGray-100",
            on: {
              "click": function($event) {
                return _vm.updateVersion(version)
              }
            }
          }, [_c('span', {
            staticClass: "font-semibold mr-1"
          }, [_vm._v("Version " + _vm._s(_vm.versionNumbers.length - index))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.showVersionSubmissionDate(version.created_at)) + ")")])])
        }), 0)]
      },
      proxy: true
    }], null, false, 357211735)
  })], 1) : _vm._e(), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": "Edit Submission",
      "styleTooltip": "top-0 right-full mt-0.5 mr-2 py-1.5"
    }
  }, [(_vm.submission.id === _vm.getMyRTUserDetails.submission_id && !_vm.studentInHardClosedRT) ? _c('button', {
    staticClass: "w-8 h-8 hover:bg-blueGray-100 rounded-full",
    on: {
      "click": function($event) {
        return _vm.goToSubmissionPage()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit text-sm"
  })]) : _vm._e()]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": _vm.flaggedByTooltipMessage,
      "styleTooltip": "top-0 right-full mt-0.5 mr-2 py-1.5"
    }
  }, [(_vm.hasTeacherPermissionsInCourse && _vm.submission.flagged_by.length > 0) ? _c('button', {
    staticClass: "w-8 h-8 hover:bg-gray-200 rounded-full"
  }, [_c('i', {
    staticClass: "fa fa-flag text-red-500",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": _vm.studentFlaggedSubmissionTooltipMessage,
      "styleTooltip": "top-0 right-full mt-0.5 mr-2 py-1.5"
    }
  }, [(_vm.userFlaggedSubmission) ? _c('button', {
    staticClass: "w-8 h-8 hover:bg-gray-200 rounded-full"
  }, [_c('i', {
    staticClass: "fa fa-flag text-red-500",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.studentHasByPassed) ? _c('Tooltip', {
    attrs: {
      "text": _vm.studentByPassedTooltipMessage,
      "styleTooltip": "top-0 right-full mt-0.5 mr-2 py-1.5"
    }
  }, [_c('button', {
    staticClass: "w-8 h-8 hover:bg-gray-200 rounded-full"
  }, [_c('i', {
    staticClass: "fas fa-exchange-alt",
    staticStyle: {
      "font-size": "13px"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('ModelResponseStar', {
    key: "model-response",
    attrs: {
      "submissionID": _vm.submission.id,
      "isModelResponse": _vm.isModelSubmission
    },
    on: {
      "addModelSubmission": _vm.addModelSubmission
    }
  })], 1), _vm._v(" "), _c('pl-menu', {
    staticClass: "z-10 rounded-xl",
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('button', {
    staticClass: "w-8 h-8 rounded-full hover:bg-gray-100",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-v text-sm text-gray-500"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "px-1 py-1",
    attrs: {
      "menu-content": ""
    }
  }, [(_vm.hasTeacherPermissionsInCourse && _vm.submission.flagged_by.length) ? _c('li', {
    staticClass: "sample rounded cursor-pointer py-1.5 px-2.5 flex space-x-2 items-center hover:bg-gray-100",
    on: {
      "click": _vm.handleUnflagSubmission
    }
  }, [_c('span', {
    staticClass: "text-blueGray-700",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Unflag")])]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('li', {
    staticClass: "sample rounded cursor-pointer py-1.5 px-2.5 w-full flex space-x-2 items-center hover:bg-gray-100",
    on: {
      "click": _vm.handleHideSubmissionClick
    }
  }, [_c('span', {
    staticClass: "text-blueGray-700",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(!_vm.submission.is_hidden ? 'Hide' : 'Reveal'))])]) : _vm._e(), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse && _vm.submission.flagged_by) ? _c('li', {
    staticClass: "sample cursor-pointer py-1.5 px-4 w-full flex justify-between items-center hover:bg-gray-100",
    class: {
      warn: !_vm.userFlaggedSubmission
    },
    on: {
      "click": function($event) {
        return _vm.toggleFlag(_vm.submission.id)
      }
    }
  }, [_c('span', {
    staticClass: "mr-3 text-xs"
  }, [_vm._v(_vm._s(_vm.userFlaggedSubmission ? 'Unflag' : 'Flag'))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.submissionTypeDraft) ? _c('li', {
    staticClass: "sample rounded py-1.5 px-2.5 cursor-pointer w-full flex space-x-2 items-center hover:bg-pink-50",
    on: {
      "click": function($event) {
        return _vm.handleOpenGenieFeedback()
      }
    }
  }, [_c('span', {
    staticClass: "text-pinky",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Genie Feedback")])]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('li', {
    staticClass: "sample rounded py-1.5 px-2.5 cursor-pointer w-full flex space-x-2 items-center hover:bg-red-50",
    on: {
      "click": _vm.deleteSubmissionModal
    }
  }, [_c('span', {
    staticClass: "text-red-500",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Delete")])]) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-151b2c4c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/submissionCard/cardHeader.vue
// module id = 1108
// module chunks = 61